// add csv to same directory as this file
// import data from './mpd.csv';

const docReady = function(func) {
  // https://stackoverflow.com/a/9899701
    // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(func, 1);
  } else {
    document.addEventListener('DOMContentLoaded', func);
  }
};

const debounce = function(func, wait, immediate) {
  // https://davidwalsh.name/javascript-debounce-function
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

docReady(() => {
  const pymChild = new pym.Child();
  pymChild.sendHeight();

  document.getElementById('expand-button').addEventListener('click', () => {
    document.getElementById('expand').classList.remove('cutoff');
    document.getElementById('expand-gradient').classList.remove('cutoff');
    document.getElementById('expand-area').classList.add('hide');
    pymChild.sendHeight();
  });

  const resizeFn = debounce(() => {
    // resize code goes here
    pymChild.sendHeight();
  }, 450);
  window.addEventListener('resize', resizeFn);
});
